export default {
  "ThirdPartyCurrentContents.Title": "設定を変更する",
  "ThirdPartyCurrentContents.LinkText":
    "ドコモグループ・NTTグループ・その他提携先とは",
  "ThirdPartyCurrentContents.Link":
    "https://id-biz.smt.docomo.ne.jp/src/utility/providing_destinations.html",
}
